var _defs, _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _polygon, _polygon2, _polygon3, _path96, _path97, _rect, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _polygon4, _ellipse, _ellipse2, _path192, _path193, _path194, _path195, _ellipse3, _ellipse4, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _ellipse5, _path319, _ellipse6, _path320, _path321, _ellipse7, _path322, _ellipse8, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBanKharTravel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 150,
    viewBox: "0 0 209.71 377.03",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 97.2,
    y: 256.31,
    width: 112.51,
    height: 120.72,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.01 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-92,194.46c.44,3.08,13.35,6.68,16.08,8.48,6.92,4.58,17,14.67,15.15,23.8-.63,3-2.56,5.63-4.68,7.89-6.81,7.22-15.86,11.68-25.13,14.87-8.85,3-18.41,4.05-25.85,10.21a9.82,9.82,0,0,0-3.37,4.39c-2.05,6.56,5.81,10.17,10.84,11.28,18.53,4.09,37.84,2.31,56.25-1.5-9.67,2-20.76-.07-30.42-1-8.94-.88-18.56-.55-26.82-4.63,14.86-9,34-11.69,49.82-19.25,10.11-4.84,17-11.12,15-23.19-1.65-9.68-7.05-18.39-13.78-25.54-5.47-5.81-11.81-10.67-18.24-15.35-2.57-1.87-17.28-9.2-17.55-11.21L-92,194.46",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 79.19,
    y1: 350.99,
    x2: 79.19,
    y2: 296.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b71c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911c24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 128.16,
    y1: 350.99,
    x2: 128.16,
    y2: 296.62,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    transform: "translate(233.01 83)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-164.89 83.45 -86.02 87.56 -85.07 141.46 -115.26 175.45 -152.53 173.69 -172.88 135.77 -164.89 83.45",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    transform: "translate(233.01 83)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -193.55,
    y: 75.38,
    width: 123.87,
    height: 97.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    transform: "translate(233.01 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-69.36,3.22c0-.93.07-1.86.07-2.79C-69.29-32.85-97.07-57-128.78-57s-59.39,23.5-59.39,56.78c0,1.16,0,2.32.11,3.47h-.11l.2,1.19a62.71,62.71,0,0,0,1.88,11.12l8.79,52.13c1.74,10.33,8.06,18.13,16.48,25.13a62.1,62.1,0,0,0,14.08,9,68.75,68.75,0,0,0,7.9,2.94h0a22.11,22.11,0,0,0,2.19.58c.73.17,1.44.3,2.11.39a40,40,0,0,0,11.69.06,24.47,24.47,0,0,0,4.09-.81,38.11,38.11,0,0,0,5.32-1.78h0c1.47-.57,2.68-1.08,3.35-1.38a62.1,62.1,0,0,0,14.08-9c8.42-7,14.74-14.8,16.48-25.13,3.62-21.48,6.56-43,10.19-64.48Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    transform: "translate(233.01 83)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.88,
    y: -61.48,
    width: 162.24,
    height: 115.52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    transform: "translate(233.01 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-176.81,165.55c-9.15-.06-17.26-4.77-17.23-10.52s8.21-10.35,17.36-10.29,10.36,4.77,10.32,10.51S-167.66,165.61-176.81,165.55Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    transform: "translate(233.01 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-81.48,165.55c9.15-.06,17.26-4.77,17.23-10.52s-8.21-10.35-17.36-10.29S-92,149.5-91.94,155.25-90.63,165.61-81.48,165.55Z",
    fill: "none"
  })))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "team-1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-92,194.46c.44,3.08,13.35,6.68,16.08,8.48,6.92,4.58,17,14.67,15.15,23.8-.63,3-2.56,5.63-4.68,7.89-6.81,7.22-15.86,11.68-25.13,14.87-8.85,3-18.41,4.05-25.85,10.21a9.82,9.82,0,0,0-3.37,4.39c-2.05,6.56,5.81,10.17,10.84,11.28,18.53,4.09,37.84,2.31,56.25-1.5-9.67,2-20.76-.07-30.42-1-8.94-.88-18.56-.55-26.82-4.63,14.86-9,34-11.69,49.82-19.25,10.11-4.84,17-11.12,15-23.19-1.65-9.68-7.05-18.39-13.78-25.54-5.47-5.81-11.81-10.67-18.24-15.35-2.57-1.87-17.28-9.2-17.55-11.21L-92,194.46",
    transform: "translate(233.01 83)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-66.58,279.54l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.73,279.94l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-62.89,269.15-55,272c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-63,269.56l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-59.21,258.77l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-59.35,259.18-51.5,262c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-63,269.56Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-55.52,248.39l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.66,248.8l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-51.83,238l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-52,238.42l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-48.14,227.63l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-48.28,228l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-52,238.42Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-44.45,217.25l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-44.6,217.66l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-48.28,228Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-40.76,206.87l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-40.91,207.28l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-37.08,196.49l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-37.22,196.9l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-71.26,272l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-71.41,272.43l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-67.58,261.65l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-67.72,262.05l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-63.89,251.27l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-64,251.67l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-67.72,262Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-60.2,240.89l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-60.34,241.29l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-64,251.67Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-56.51,230.51l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-56.65,230.91l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-52.82,220.13l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-53,220.53l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-49.13,209.75l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-49.28,210.15l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-53,220.53Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-45.45,199.37l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-45.59,199.77l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-79.63,274.9l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-79.78,275.3l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-75.95,264.52l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.09,264.92l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-72.26,254.14l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-72.4,254.54l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-68.57,243.76l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-68.71,244.16l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-64.88,233.38l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-65,233.78l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-61.19,223l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-61.34,223.4l7.85,2.79C-48.06,228.12-48,234-48,234s-3.74,4.51-9.16,2.59L-65,233.78Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-57.5,212.62l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-57.65,213l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-53.82,202.24l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M-54,202.64l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-57.65,213Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-50.13,191.86l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79L-54.1,203Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M-50.27,192.26l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-54,202.64Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-84.32,267.39l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M-84.46,267.79l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-80.63,257l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M-80.77,257.41l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.94,246.63l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M-77.08,247l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-73.25,236.25l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M-73.39,236.65l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-77.08,247Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-69.56,225.87l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-69.71,226.27l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-65.87,215.49l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-66,215.89l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-62.19,205.11l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.33,205.51l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-66,215.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-58.5,194.73l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-58.64,195.13l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-92.69,270.26l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.83,270.66l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-96.52,281Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-89,259.88l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-89.14,260.28l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-85.31,249.5l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-85.45,249.9l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-81.62,239.12l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-81.76,239.52l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-77.93,228.74l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M-78.08,229.14l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-74.24,218.36l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-74.39,218.76l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-70.56,208l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-70.7,208.38l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-66.87,197.6l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-67,198l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-63.18,187.22l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-63.32,187.62l7.85,2.79C-50,192.34-50,198.2-50,198.2s-3.74,4.51-9.16,2.59L-67,198Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-97.37,262.75l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.51,263.16l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-93.68,252.37l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M-93.82,252.78l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-90,242l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-90.13,242.4l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86.3,231.61l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.45,232l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-82.61,221.23l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-82.76,221.63l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-86.44,232Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-78.93,210.85l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79L-82.9,222Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-79.07,211.25l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-75.24,200.47l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-75.38,200.87l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79S-65.8,216-71.22,214l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-71.55,190.09l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-71.69,190.49l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-105.74,265.62l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-105.88,266l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-102,255.24l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.19,255.65l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-98.36,244.86l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M-98.5,245.27l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-94.67,234.48l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M-94.82,234.88l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-91,224.1l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M-91.13,224.5l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-87.3,213.72l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M-87.44,214.12l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-83.61,203.34l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M-83.75,203.74l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-79.92,193l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M-80.06,193.36l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.23,182.58l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.37,183l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-110.42,258.11l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M-110.56,258.52l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.73,247.73l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.87,248.14l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-103,237.35l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M-103.19,237.76l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-99.35,227l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M-99.5,227.38l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-95.67,216.59l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M-95.81,217l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-92,206.21l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79L-96,217.4Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.12,206.62l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59L-95.81,217Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-88.29,195.83l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M-88.43,196.24l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-84.6,185.45l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.87,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M-84.74,185.86l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79S-75.16,201-80.58,199l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-118.79,261l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M-118.93,261.39l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-115.1,250.6l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M-115.24,251l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-111.41,240.22l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M-111.56,240.63l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-107.72,229.84l7.87,2.8C-94,234.72-94,241-94,241s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.87,230.25-100,233c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-104,219.46l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M-104.18,219.87l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79S-94.59,235-100,233l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-100.35,209.08l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M-100.49,209.49l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96.66,198.7l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M-96.8,199.11-89,201.9c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-93,188.32l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M-93.11,188.73l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-89.28,177.94l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M-89.43,178.35l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-123.47,253.48l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M-123.61,253.88l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79S-114,269-119.45,267l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-119.78,243.1l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M-119.93,243.5l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-116.09,232.72l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M-116.24,233.12l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-112.41,222.34l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M-112.55,222.74l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-108.72,212l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M-108.86,212.36l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-105,201.58l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M-105.17,202l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-101.34,191.2l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M-101.48,191.6l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-97.65,180.82l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.8,181.22l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-131.84,256.35l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M-132,256.75l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-128.15,246l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M-128.3,246.37l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-124.46,235.59l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M-124.61,236l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-120.78,225.21l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M-120.92,225.61l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-117.09,214.83l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.23,215.23l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-113.4,204.45l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M-113.54,204.85l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-109.71,194.07l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M-109.85,194.47l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106,183.69l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.17,184.09l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-102.33,173.31l7.87,2.8c5.84,2.08,5.9,8.39,5.9,8.39s-4,4.87-9.88,2.79l-7.87-2.8Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.48,173.71l7.85,2.79c5.42,1.93,5.48,7.79,5.48,7.79s-3.74,4.51-9.16,2.59l-7.85-2.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "91.06 296.62 81.13 326.82 86.1 332.43 81.13 350.99 73.8 350.99 76.39 326.39 67.32 296.62 91.06 296.62",
    fill: "url(#b)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.3 296.62 126.22 326.82 121.26 332.43 126.22 350.99 133.56 350.99 130.97 326.39 140.03 296.62 116.3 296.62",
    fill: "url(#c)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.14 174.93 174.11 164.14 104.87 164.14 103.77 164.14 34.53 164.14 9.5 174.93 3.03 210.31 40.57 241.81 46.61 233.61 33.66 202.98 25.04 202.98 34.53 196.93 37.98 187.01 42.3 206 61.28 256.05 63.01 267.27 63.01 298.77 103.77 298.77 104.87 298.77 145.63 298.77 145.63 267.27 147.35 256.05 166.34 206 170.66 187.01 174.11 196.93 183.6 202.98 174.97 202.98 162.03 233.61 168.07 241.81 205.61 210.31 199.14 174.93",
    fill: "#b71c24"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M-150.58,276.62l-20.28,3.45s-7.34-.86-2.59-7.77l14.24-4.32h7.34Z",
    transform: "translate(233.01 83)",
    fill: "#9b1b28"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.89,276.62l20.28,3.45s7.34-.86,2.59-7.77L-99.26,268h-7.34Z",
    transform: "translate(233.01 83)",
    fill: "#9b1b28"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.92,
    y: 157.85,
    width: 139.33,
    height: 109.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-211.52,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16S-233,226.69-233,215.46V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M-212.29,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-191.56,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M-192.34,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-171.61,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M-172.39,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-151.66,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.43,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-131.71,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M-132.48,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-111.75,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M-112.53,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-91.8,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.57,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-71.85,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M-72.62,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-51.9,200.33v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M-52.67,200.33v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V200.33Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-201.54,187.79v15.13c0,11.23-10.75,15.16-10.75,15.16S-223,214.15-223,202.92V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M-202.32,187.79v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-181.59,187.79v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M-182.36,187.79v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-161.64,187.79v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.41,187.79v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-141.68,187.79v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M-142.46,187.79v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-121.73,187.79v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.51,187.79v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-101.78,187.79v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.55,187.79v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-81.83,187.79v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M-82.6,187.79v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-61.87,187.79v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.65,187.79v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V187.79Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-211.52,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16S-233,201.61-233,190.37V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M-212.29,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-191.56,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M-192.34,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-171.61,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M-172.39,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-151.66,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.43,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-131.71,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M-132.48,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-111.75,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M-112.53,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-91.8,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.57,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-71.85,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M-72.62,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-51.9,175.24v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M-52.67,175.24v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V175.24Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-201.54,162.7v15.13c0,11.23-10.75,15.16-10.75,15.16S-223,189.06-223,177.83V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M-202.32,162.7v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-181.59,162.7v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M-182.36,162.7v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-161.64,162.7v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.41,162.7v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-141.68,162.7v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M-142.46,162.7v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-121.73,162.7v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.51,162.7v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-101.78,162.7v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.55,162.7v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-81.83,162.7v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M-82.6,162.7v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-61.87,162.7v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.65,162.7v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V162.7Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-211.52,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16S-233,176.52-233,165.29V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M-212.29,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-191.56,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M-192.34,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-171.61,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M-172.39,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-151.66,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.43,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-131.71,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M-132.48,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-111.75,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M-112.53,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-91.8,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.57,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-71.85,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M-72.62,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-51.9,150.16v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M-52.67,150.16v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V150.16Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-201.54,137.61v15.13c0,11.23-10.75,15.16-10.75,15.16S-223,164-223,152.74V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M-202.32,137.61V152.7c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-181.59,137.61v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M-182.36,137.61V152.7c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-161.64,137.61v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.41,137.61V152.7c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-141.68,137.61v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M-142.46,137.61V152.7c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-121.73,137.61v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.51,137.61V152.7c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-101.78,137.61v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.55,137.61V152.7c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-81.83,137.61v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M-82.6,137.61V152.7c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-61.87,137.61v15.13c0,11.23-10.75,15.16-10.75,15.16S-83.37,164-83.37,152.74V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.65,137.61V152.7c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V137.61Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-211.52,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16S-233,151.43-233,140.2V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M-212.29,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-191.56,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M-192.34,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-171.61,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M-172.39,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-151.66,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.43,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-131.71,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M-132.48,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-111.75,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M-112.53,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-91.8,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.57,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-71.85,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M-72.62,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-51.9,125.07V140.2c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M-52.67,125.07v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V125.07Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-201.54,112.52v15.13c0,11.23-10.75,15.16-10.75,15.16S-223,138.89-223,127.65V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M-202.32,112.52v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-181.59,112.52v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M-182.36,112.52v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-161.64,112.52v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.41,112.52v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-141.68,112.52v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M-142.46,112.52v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-121.73,112.52v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.51,112.52v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-101.78,112.52v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.55,112.52v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-81.83,112.52v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M-82.6,112.52v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-61.87,112.52v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.65,112.52v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V112.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-211.52,100v15.13c0,11.23-10.75,15.16-10.75,15.16S-233,126.34-233,115.11V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M-212.29,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-191.56,100v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M-192.34,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-171.61,100v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M-172.39,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-151.66,100v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.43,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-131.71,100v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M-132.48,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-111.75,100v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M-112.53,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-91.8,100v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.57,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-71.85,100v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M-72.62,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-51.9,100v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V100Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M-52.67,100v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V100Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-201.54,87.44v15.13c0,11.23-10.75,15.16-10.75,15.16S-223,113.8-223,102.57V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M-202.32,87.44v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-181.59,87.44v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M-182.36,87.44v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-161.64,87.44v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.41,87.44v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-141.68,87.44v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M-142.46,87.44v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-121.73,87.44v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.51,87.44v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-101.78,87.44v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.55,87.44v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-81.83,87.44v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M-82.6,87.44v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-61.87,87.44v15.13c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.65,87.44v15.09c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V87.44Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-211.52,74.89V90c0,11.23-10.75,15.16-10.75,15.16S-233,101.25-233,90V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M-212.29,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-191.56,74.89V90c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M-192.34,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-171.61,74.89V90c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M-172.39,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-151.66,74.89V90c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.43,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-131.71,74.89V90c0,11.23-10.75,15.16-10.75,15.16S-153.2,101.25-153.2,90V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M-132.48,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-111.75,74.89V90c0,11.23-10.75,15.16-10.75,15.16s-10.75-3.93-10.75-15.16V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M-112.53,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-91.8,74.89V90c0,11.23-10.75,15.16-10.75,15.16S-113.3,101.25-113.3,90V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.57,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-71.85,74.89V90c0,11.23-10.75,15.16-10.75,15.16S-93.34,101.25-93.34,90V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M-72.62,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-51.9,74.89V90c0,11.23-10.75,15.16-10.75,15.16S-73.39,101.25-73.39,90V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M-52.67,74.89V90c0,10.42-10,14.07-10,14.07s-10-3.65-10-14.07V74.89Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "67.35 166.45 146.22 170.56 147.17 224.46 116.98 258.45 79.71 256.69 59.35 218.77 67.35 166.45",
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.74,
    cy: 268.52,
    rx: 3.16,
    ry: 3.15,
    fill: "#4e4f50"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.74,
    cy: 279.11,
    rx: 3.16,
    ry: 3.15,
    fill: "#4e4f50"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M-160.06,81.14C-181,92-171.52,143.63-171.52,143.63l16.44,35.93,29-4.91c.09-6.41-34.07-24.81-34.07-24.81C-178.86,145.92-160.06,81.14-160.06,81.14Z",
    transform: "translate(233.01 83)",
    fill: "#c3bebc"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M-153.3,179.18s-40.07-54.78-3.7-97L-171.21,79s-5.64,6.06-7.24,10.75c0,0,5.34,8.38,6.88,8.26l-13.8,3.09c3,33.83,32.08,79.14,29.89,81.1A8.66,8.66,0,0,0-153.3,179.18Z",
    transform: "translate(233.01 83)",
    fill: "#9b1b28"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.16,81.14C-76.22,92-85.7,143.63-85.7,143.63l-16.44,35.93-29-4.91c-.09-6.41,34.07-24.81,34.07-24.81C-78.36,145.92-97.16,81.14-97.16,81.14Z",
    transform: "translate(233.01 83)",
    fill: "#a09793"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M-103.92,179.18s40.07-54.78,3.7-97L-86,79s5.64,6.06,7.24,10.75c0,0-5.34,8.38-6.88,8.26l13.8,3.09c-3,33.83-32.08,79.14-29.89,81.1A8.66,8.66,0,0,1-103.92,179.18Z",
    transform: "translate(233.01 83)",
    fill: "#9b1b28"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -101.93,
    cy: 159.95,
    rx: 2.16,
    ry: 2.26,
    transform: "translate(84.39 59.12) rotate(-46.76)",
    fill: "#767371"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -112.78,
    cy: 171.48,
    rx: 2.16,
    ry: 2.26,
    transform: "translate(72.56 54.85) rotate(-46.76)",
    fill: "#767371"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M-90.39,6.77",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("image", {
    width: 203,
    height: 230,
    transform: "translate(4.01)",
    opacity: 0.38,
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-116.3,100.28v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V100.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M-117,100.28v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V100.28Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.28,87.62v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V87.62Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M-148,87.62v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V87.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-126.86,87.62v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V87.62Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.56,87.62v15.29c0,10.56-10.21,14.25-10.21,14.25S-148,113.46-148,102.91V87.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.44,87.62v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V87.62Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.15,87.62v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V87.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86,87.62v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V87.62Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.73,87.62v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V87.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-157.13,75V90.42c0,11.48-10.91,15.49-10.91,15.49S-179,101.9-179,90.42V75Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.84,75V90.25c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V75h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-136.72,75V90.42c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V75Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.42,75V90.25c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V75h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-116.3,75V90.42c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V75Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M-117,75V90.25c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V75H-117Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-95.88,75V90.42c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V75Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M-96.59,75V90.25c0,10.56-10.21,14.25-10.21,14.25S-117,100.8-117,90.25V75h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.17,75V90.42c0,11.48-10.91,15.49-10.91,15.49S-98,101.9-98,90.42V75Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.87,75V90.25c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V75h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-167,62.3V77.76c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M-167.69,62.3V77.59c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.28,62.3V77.76c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M-148,62.3V77.59c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-126.86,62.3V77.76c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.56,62.3V77.59c0,10.56-10.21,14.25-10.21,14.25S-148,88.14-148,77.59V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.44,62.3V77.76c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.15,62.3V77.59c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86,62.3V77.76c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.73,62.3V77.59c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-65.61,62.3V77.76c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.31,62.3V77.59c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V62.3Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-157.13,49.64V65.1c0,11.48-10.91,15.49-10.91,15.49S-179,76.57-179,65.1V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.84,49.64V64.93c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-136.72,49.64V65.1c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.42,49.64V64.93c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-116.3,49.64V65.1c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M-117,49.64V64.93c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-95.88,49.64V65.1c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M-96.59,49.64V64.93c0,10.56-10.21,14.25-10.21,14.25S-117,75.48-117,64.93V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.17,49.64V65.1c0,11.48-10.91,15.49-10.91,15.49S-98,76.57-98,65.1V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.87,49.64V64.93c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V49.64Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-167,36.27V51.73c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.27Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M-167.69,37V52.26c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V37Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.28,36.27V51.73c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.27Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M-148,37V52.26c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V37Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-126.86,36.27V51.73c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.27Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.56,37V52.26c0,10.56-10.21,14.25-10.21,14.25S-148,62.81-148,52.26V37Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.44,36.27V51.73c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.27Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.15,37V52.26c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V37Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86,36.27V51.73c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.27Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.73,37V52.26c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V37Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-65.61,36.27V51.73c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.27Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.31,37V52.26c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V37Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-198,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M-198.68,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V48.94h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-177.56,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M-178.26,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V48.94h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-157.14,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49S-179,75.88-179,64.4V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.85,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V48.94h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-136.73,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.43,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V48.94h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-117,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.72,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V48.94h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96.6,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.3,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V48.94H-97.3Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.18,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49S-98,75.88-98,64.4V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.88,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25S-97.3,74.78-97.3,64.23V48.94h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-55.76,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M-56.47,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V48.94h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-35.34,48.94V64.4c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V48.94Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M-36,48.95V64.23c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V48.94H-36Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-188.12,36.28V51.74c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M-188.82,36.28V51.57c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-167.7,36.28V51.74c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M-168.41,36.28V51.57c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.29,36.28V51.74c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M-148,36.28V51.57c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-126.87,36.28V51.74c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.57,36.28V51.57c0,10.56-10.21,14.25-10.21,14.25S-148,62.12-148,51.57V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.45,36.28V51.74c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.16,36.28V51.57c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86,36.28V51.74c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.74,36.28V51.57c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-65.62,36.28V51.74c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.32,36.28V51.57c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-45.91,36.28V51.74c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M-46.61,36.28V51.57c0,10.56-10.21,14.25-10.21,14.25S-67,62.12-67,51.57V36.28Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-198,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M-198.68,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-177.56,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M-178.26,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-157.14,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49S-179,49.85-179,38.37V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.85,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-136.73,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.43,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-117,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.72,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96.6,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.3,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.18,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49S-98,49.85-98,38.37V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.88,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25S-97.3,49.46-97.3,38.91V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-55.76,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M-56.47,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-35.34,22.91V38.37c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V22.91Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M-36,23.62V38.91c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V23.62Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-188.12,10.25V25.72C-188.12,37.19-199,41.2-199,41.2s-10.91-4-10.91-15.49V10.26h21.83Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M-188.82,10.25V25.54C-188.82,36.1-199,39.8-199,39.8s-10.21-3.71-10.21-14.25V10.25Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-167.7,10.25V25.72c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V10.26h21.83Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M-168.41,10.25V25.54c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V10.25Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.29,10.25V25.72c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V10.26h21.83Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M-148,10.25V25.54C-148,36.1-158.2,39.8-158.2,39.8s-10.21-3.71-10.21-14.25V10.25Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-126.87,10.25V25.72c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V10.26h21.83Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.57,10.25V25.54c0,10.56-10.21,14.25-10.21,14.25S-148,36.09-148,25.54V10.25Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.45,10.25V25.72c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V10.26h21.83Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.16,10.25V25.54c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V10.25Z",
    transform: "translate(233.01 83)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86,10.25V25.72C-86,37.19-96.95,41.2-96.95,41.2s-10.91-4-10.91-15.49V10.26H-86Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.74,10.25V25.54c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V10.25Z",
    transform: "translate(233.01 83)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-65.62,10.25V25.72c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V10.26h21.83Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.32,10.25V25.54c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V10.25Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-45.91,10.25V25.72c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V10.26h21.83Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M-46.61,10.25V25.54c0,10.56-10.21,14.25-10.21,14.25S-67,36.09-67,25.54V10.25Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-198-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M-198.68-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-177.56-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M-178.26-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-157.14-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49S-179,24.53-179,13.05V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.85-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-136.73-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.43-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-117-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.72-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96.6-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.3-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.18-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49S-98,24.53-98,13.05V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.88-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25S-97.3,23.43-97.3,12.88V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-55.76-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M-56.47-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-35.34-2.41V13.05c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M-36-2.41V12.88c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-2.41Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-188.12-15.07V.39c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M-188.82-15.07V.22c0,10.56-10.21,14.25-10.21,14.25S-209.24,10.77-209.24.22V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-167.7-15.07V.39c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M-168.41-15.07V.22c0,10.56-10.21,14.25-10.21,14.25S-188.82,10.77-188.82.22V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.29-15.07V.39c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M-148-15.07V.22c0,10.56-10.21,14.25-10.21,14.25S-168.41,10.77-168.41.22V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-126.87-15.07V.39c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.57-15.07V.22c0,10.56-10.21,14.25-10.21,14.25S-148,10.77-148,.22V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.45-15.07V.39c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.16-15.07V.22c0,10.56-10.21,14.25-10.21,14.25S-127.57,10.77-127.57.22V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86-15.07V.39c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.74-15.07V.22c0,10.56-10.21,14.25-10.21,14.25S-107.16,10.77-107.16.22V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-65.62-15.07V.39c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.32-15.07V.22c0,10.56-10.21,14.25-10.21,14.25S-86.74,10.77-86.74.22V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-45.91-15.07V.39c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M-46.61-15.07V.22c0,10.56-10.21,14.25-10.21,14.25S-67,10.77-67,.22V-15.07Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-198-27.73v15.46C-198-.8-208.89,3.22-208.89,3.22s-10.91-4-10.91-15.49V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M-198.68-27.73v15.29c0,10.56-10.21,14.25-10.21,14.25S-219.1-1.89-219.1-12.44V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-177.56-27.73v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M-178.26-27.73v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-157.14-27.73v15.46c0,11.48-10.91,15.49-10.91,15.49S-179-.8-179-12.27V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.85-27.73v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-136.73-27.73v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.43-27.73v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-117-27.73v15.46C-117-.8-127.93,3.22-127.93,3.22s-10.91-4-10.91-15.49V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.72-27.73v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96.6-27.73v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.3-27.73v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.18-27.73v15.46C-76.18-.8-87.09,3.22-87.09,3.22S-98-.8-98-12.27V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.88-27.73v15.29c0,10.56-10.21,14.25-10.21,14.25S-97.3-1.89-97.3-12.44V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-55.76-27.73v15.46C-55.76-.8-66.67,3.22-66.67,3.22s-10.91-4-10.91-15.49V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M-56.47-27.73v15.29c0,10.56-10.21,14.25-10.21,14.25S-76.88-1.89-76.88-12.44V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-35.34-27.73v15.46C-35.34-.8-46.26,3.22-46.26,3.22s-10.91-4-10.91-15.49V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M-36-27.73v15.29C-36-1.88-46.26,1.81-46.26,1.81S-56.47-1.89-56.47-12.44V-27.73Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-188.12-40.39v15.46C-188.12-13.46-199-9.44-199-9.44s-10.91-4-10.91-15.49V-40.39Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M-188.82-40.39V-25.1c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V-40.38h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-167.7-40.39v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-40.39Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M-168.41-40.39V-25.1c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V-40.38h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.29-40.39v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-40.39Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M-148-40.39V-25.1c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V-40.38H-148Z",
    transform: "translate(233.01 83)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-126.87-40.39v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-40.39Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.57-40.39V-25.1c0,10.56-10.21,14.25-10.21,14.25S-148-14.55-148-25.1V-40.38h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.45-40.39v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-40.39Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.16-40.39V-25.1c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V-40.38h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86-40.39v15.46C-86-13.46-96.95-9.44-96.95-9.44s-10.91-4-10.91-15.49V-40.39Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.74-40.39V-25.1c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V-40.38h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-65.62-40.39v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-40.39Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.32-40.39V-25.1c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.7-10.21-14.25V-40.38h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-45.91-40.39v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-40.39Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M-46.61-40.39V-25.1c0,10.56-10.21,14.25-10.21,14.25S-67-14.55-67-25.1V-40.38h20.42Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-198-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M-198.68-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-177.56-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M-178.26-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-157.14-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49S-179-26.12-179-37.6V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.85-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-136.73-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.43-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-117-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.72-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96.6-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.3-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.18-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49S-98-26.12-98-37.6V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.88-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25S-97.3-27.22-97.3-37.77V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-55.76-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M-56.47-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-35.34-53.06V-37.6c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M-36-53.06v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-53.06Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-188.12-65.72v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M-188.82-65.72v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-167.7-65.72v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M-168.41-65.72v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.29-65.72v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M-148-65.72v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-126.87-65.72v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.57-65.72v15.29c0,10.56-10.21,14.25-10.21,14.25S-148-39.88-148-50.43V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-106.45-65.72v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.16-65.72v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86-65.72v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M-86.74-65.72v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-65.62-65.72v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.32-65.72v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-45.91-65.72v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M-46.61-65.72v15.29c0,10.56-10.21,14.25-10.21,14.25S-67-39.88-67-50.43V-65.72Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-198-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M-198.68-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-177.56-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M-178.26-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-157.14-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49S-179-52.15-179-63.62V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.85-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-136.73-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.43-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-117-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.72-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96.6-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.3-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-76.18-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49S-98-52.15-98-63.62V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M-76.88-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25S-97.3-52.54-97.3-63.09V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-55.76-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M-56.47-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-35.34-79.08v15.46c0,11.48-10.91,15.49-10.91,15.49s-10.91-4-10.91-15.49V-79.08Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M-36-78.38v15.29c0,10.56-10.21,14.25-10.21,14.25s-10.21-3.71-10.21-14.25V-78.38Z",
    transform: "translate(233.01 83)",
    fill: "#b99664"
  })))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M-71.84-16.66c.15,0-2.27-9.42-11.49-22.5a42.54,42.54,0,0,0-9.58-10.31c-14.11-11.8-34.26-13.1-56.32-6.18l-.09,0c-9.59,3.56-19.72,9.3-29,1.43a38.81,38.81,0,0,0,4.82,16.3v0c-12.19,13.45-13.37,25.52-13.37,25.52,7.85-15.06,19.41-17.92,19.41-17.92l0,0c5.41,4.9,13.51,8.47,25.67,8A94.06,94.06,0,0,0-129.62-24a69.41,69.41,0,0,0,9.18-2.54c7.13-2.53,10.88-5.11,18.6-6.08C-83.58-34.92-71.84-16.66-71.84-16.66Z",
    transform: "translate(233.01 83)",
    fill: "#262322"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -163.56,
    cy: 21.3,
    rx: 22.89,
    ry: 20.98,
    transform: "translate(227.4 56.78) rotate(-9.32)",
    fill: "#4a4a4c"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.57,32.45c7.69-1.26,13-8,11.85-15.08s-8.36-11.76-16.05-10.5-13,8-11.85,15.08S-170.27,33.72-162.57,32.45Z",
    transform: "translate(233.01 83)",
    fill: "#f2eded"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.34,
    cy: 103.16,
    rx: 1.41,
    ry: 9.86,
    fill: "#2b2626"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M-182.8,10.41s13.69-11.33,42.38,9.78c0,0-1.16-18.5-19-20.49C-159.42-.3-174.62-2.64-182.8,10.41Z",
    transform: "translate(233.01 83)",
    fill: "#957950"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M-142.73,29.41s-32,21.21-43.54-9.77c0,0-2.8,19.81,18.6,23.38C-167.67,43-150.44,45.28-142.73,29.41Z",
    transform: "translate(233.01 83)",
    fill: "#957950"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -92.63,
    cy: 21.27,
    rx: 20.98,
    ry: 22.89,
    transform: "translate(134.4 9.42) rotate(-80.68)",
    fill: "#4a4a4c"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M-93.59,32.26c-7.59-1.25-12.84-7.92-11.7-14.88S-97,5.77-89.44,7s12.84,7.92,11.7,14.88S-86,33.51-93.59,32.26Z",
    transform: "translate(233.01 83)",
    fill: "#f2eded"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.5,
    cy: 103.13,
    rx: 1.39,
    ry: 9.73,
    fill: "#2b2626"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M-73.39,10.38S-87.08-1-115.77,20.16c0,0,1.16-18.5,19-20.49C-96.77-.33-81.57-2.67-73.39,10.38Z",
    transform: "translate(233.01 83)",
    fill: "#957950"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M-113.46,29.38s32,21.21,43.54-9.77c0,0,2.8,19.81-18.6,23.38C-88.51,43-105.75,45.25-113.46,29.38Z",
    transform: "translate(233.01 83)",
    fill: "#957950"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-170.8,162.84l10.12-.52c7.51-.39,9.77-7.71,9.77-7.71s-3-7.06-10.51-6.67l-10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M-170.83,162.33l10.09-.52c7-.36,9.07-7.16,9.07-7.16s-2.78-6.55-9.75-6.19l-10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-179.53,156.6l10.12-.52c7.51-.39,9.77-7.71,9.77-7.71s-3-7.06-10.51-6.67l-10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M-179.56,156.09l10.09-.52c7-.36,9.07-7.16,9.07-7.16s-2.78-6.55-9.75-6.19l-10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-178.85,170l10.12-.52c7.51-.39,9.77-7.71,9.77-7.71s-3-7.06-10.51-6.67l-10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M-178.88,169.43l10.09-.52c7-.36,9.07-7.16,9.07-7.16s-2.78-6.55-9.75-6.19l-10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M-188.29,149.84l10.09-.52c7-.36,9.07-7.16,9.07-7.16s-2.78-6.55-9.75-6.19l-10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-187.58,163.71l10.12-.52c7.51-.39,9.77-7.71,9.77-7.71s-3-7.06-10.51-6.67l-10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M-187.61,163.19l10.09-.52c7-.36,9.07-7.16,9.07-7.16s-2.78-6.55-9.75-6.19l-10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-196.32,157.46l10.12-.52c7.51-.39,9.77-7.71,9.77-7.71s-3-7.06-10.51-6.67l-10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M-196.34,156.95l10.09-.52c7-.36,9.07-7.16,9.07-7.16s-2.78-6.55-9.75-6.19l-10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-195.63,170.81l10.12-.52c7.51-.39,9.77-7.71,9.77-7.71s-3-7.06-10.51-6.67l-10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M-195.66,170.29l10.09-.52c7-.36,9.07-7.16,9.07-7.16s-2.78-6.55-9.75-6.19l-10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-204.37,164.57l10.12-.52c7.51-.39,9.77-7.71,9.77-7.71s-3-7.06-10.51-6.67l-10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M-204.39,164l10.09-.52c7-.36,9.07-7.16,9.07-7.16s-2.78-6.55-9.75-6.19l-10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-87.5,162.84l-10.12-.52c-7.51-.39-9.77-7.71-9.77-7.71s3-7.06,10.51-6.67l10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M-87.47,162.33l-10.09-.52c-7-.36-9.07-7.16-9.07-7.16s2.78-6.55,9.75-6.19l10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-78.76,156.6l-10.12-.52c-7.51-.39-9.77-7.71-9.77-7.71s3-7.06,10.51-6.67l10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M-78.73,156.09l-10.09-.52c-7-.36-9.07-7.16-9.07-7.16s2.78-6.55,9.75-6.19l10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-79.45,170l-10.12-.52c-7.51-.39-9.77-7.71-9.77-7.71s3-7.06,10.51-6.67l10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M-79.42,169.43l-10.09-.52c-7-.36-9.07-7.16-9.07-7.16s2.78-6.55,9.75-6.19l10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M-70,149.84l-10.09-.52c-7-.36-9.07-7.16-9.07-7.16s2.78-6.55,9.75-6.19l10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-70.71,163.71l-10.12-.52c-7.51-.39-9.77-7.71-9.77-7.71s3-7.06,10.51-6.67l10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M-70.69,163.19l-10.09-.52c-7-.36-9.07-7.16-9.07-7.16s2.78-6.55,9.75-6.19l10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-62,157.46l-10.12-.52c-7.51-.39-9.77-7.71-9.77-7.71s3-7.06,10.51-6.67l10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M-62,156.95-72,156.43c-7-.36-9.07-7.16-9.07-7.16s2.78-6.55,9.75-6.19l10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-62.66,170.81l-10.12-.52c-7.51-.39-9.77-7.71-9.77-7.71s3-7.06,10.51-6.67l10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.64,170.29l-10.09-.52c-7-.36-9.07-7.16-9.07-7.16s2.78-6.55,9.75-6.19l10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-53.93,164.57-64,164c-7.51-.39-9.77-7.71-9.77-7.71s3-7.06,10.51-6.67l10.12.52Z",
    transform: "translate(233.01 83)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M-53.9,164-64,163.53c-7-.36-9.07-7.16-9.07-7.16s2.78-6.55,9.75-6.19l10.09.52Z",
    transform: "translate(233.01 83)",
    fill: "#4d4d4f"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBanKharTravel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ban-khar-travel.b6cc9299.svg";
export { ForwardRef as ReactComponent };